/** Màu nền avatar chữ — chọn theo 2 ký tự initials (hash ổn định). */
export const AVATAR_INITIAL_COLORS = [
  '#E57373',
  '#F06292',
  '#BA68C8',
  '#9575CD',
  '#7986CB',
  '#64B5F6',
  '#4FC3F7',
  '#4DD0E1',
  '#4DB6AC',
  '#81C784',
  '#AED581',
  '#FFD54F',
  '#FFB74D',
  '#FF8A65',
  '#A1887F',
  '#90A4AE',
];

const PLACEHOLDER_AVATAR_URLS = [
  '/img/logo_small.png',
  '/img/profile/avatar.png',
  '/img/group/group_image_low.jpg',
  '/img/group/user-group.svg',
];

/**
 * @param {string|null|undefined} name
 * @returns {string}
 */
export function getAvatarInitials(name) {
  const raw = String(name || '').trim();
  if (!raw) {
    return '??';
  }

  const words = raw.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    const first = words[0].charAt(0);
    const last = words[words.length - 1].charAt(0);
    return `${first}${last}`.toUpperCase();
  }

  const compact = raw.replace(/\s+/g, '');
  if (compact.length >= 2) {
    return compact.substring(0, 2).toUpperCase();
  }

  const ch = compact.charAt(0) || '?';
  return `${ch}${ch}`.toUpperCase();
}

/**
 * @param {string} initials
 * @returns {string}
 */
export function getAvatarColorFromInitials(initials) {
  const key = String(initials || '')
    .toUpperCase()
    .replace(/[^A-Z0-9\u00C0-\u024F\u1E00-\u1EFF]/g, '');

  if (!key) {
    return AVATAR_INITIAL_COLORS[0];
  }

  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }

  return AVATAR_INITIAL_COLORS[Math.abs(hash) % AVATAR_INITIAL_COLORS.length];
}

/**
 * @param {string|null|undefined} url
 * @returns {boolean}
 */
export function isPlaceholderAvatarUrl(url) {
  if (!url || typeof url !== 'string') {
    return true;
  }

  const normalized = url.trim().toLowerCase();
  if (!normalized) {
    return true;
  }

  return PLACEHOLDER_AVATAR_URLS.some((placeholder) => normalized.includes(placeholder.toLowerCase()));
}

/**
 * @param {{ image?: string|null, thumbnail?: Record<string, string>|null, size?: string|null }} params
 * @returns {string|null}
 */
export function resolveAvatarImageUrl({ image = null, thumbnail = null, size = null }) {
  let url = null;

  if (thumbnail && typeof thumbnail === 'object') {
    if (size === 'medium') {
      url = thumbnail.medium_thumb || thumbnail.thumb || thumbnail.url || null;
    } else if (size === 'small') {
      url = thumbnail.small_thumb || thumbnail.thumb || thumbnail.url || null;
    } else {
      url = thumbnail.medium_thumb || thumbnail.small_thumb || thumbnail.thumb || thumbnail.url || null;
    }
  }

  if (!url && image) {
    url = image;
  }

  if (!url || isPlaceholderAvatarUrl(url)) {
    return null;
  }

  return String(url);
}

/**
 * @param {string|null|undefined} name
 * @returns {{ initials: string, backgroundColor: string, color: string }}
 */
export function buildAvatarInitialsStyle(name) {
  const initials = getAvatarInitials(name);

  return {
    initials,
    backgroundColor: getAvatarColorFromInitials(initials),
    color: '#ffffff',
  };
}
